// extracted by mini-css-extract-plugin
export default {"review_sales_page":"styles_review_sales_page__todUi","brand_model":"styles_brand_model__Pj6rG"};